import { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  Fab,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import { GrabsContext } from "../../../context/GrabsContext";
import { useTheme } from "@emotion/react";
import usePullRequests from "../../../customHooks/usePullRequests";
import TextFieldDebounced from "../../../component/TextFieldDebounced";
import InfiniteScrollerTable from "../../../component/InfiniteScroller/InfiniteScrollerTable";
import ListFooter from "../../../component/InfiniteScroller/ListFooter";
import momentPhoenix from "../../../helpers/momentPhoenix";
import useStockoutsAndPulls from "../../../customHooks/useStockoutsAndPulls";

const StockoutsAndPullsNeedToPost = () => {
  const navigate = useNavigate();
  const { authToken } = useContext(AuthContext);
  const { clearGrabs } = useContext(GrabsContext);
  const {
    searchQuery,
    setSearchQuery,
    status,
    setStatus,
    results,
    onRefresh,
    refreshing,
    onLoadMore,
    loadingMore,
    total,
    hasMore,
  } = useStockoutsAndPulls(authToken, 50, "pending");
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <div
        style={{
          display: "flex",
          position: "relative",
          flexDirection: "row",
          marginTop: 16,
          // paddingLeft: 16,
          // paddingRight: 16,
          justifyContent: isSmallScreen ? "center" : "flex-end",
        }}
      >
        <TextFieldDebounced
          placeholder="search..."
          value={searchQuery}
          size="small"
          sx={{
            width: isSmallScreen ? "100%" : 270,
            // marginRight: isSmallScreen ? 0 : "8px",
            // marginTop: isSmallScreen ? "8px" : 0,
          }}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <InfiniteScrollerTable
        TableContainerComponent={Box}
        TableStyle={{ minWidth: "650px" }}
        TableHead={() => (
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>ID</TableCell>
              <TableCell>Requested By</TableCell>
              <TableCell>Pulled By</TableCell>
              <TableCell>Job</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Posted</TableCell>
            </TableRow>
          </TableHead>
        )}
        items={results}
        renderRow={(item, index) => {
          return (
            <TableRow
              onClick={() => navigate(`/pull-requests/${item.id}`)}
              key={index}
              sx={{
                // "& td": { border: 0 },
                cursor: "pointer",
                "&:hover": {
                  background:
                    theme.palette.mode == "dark"
                      ? theme.palette.primary.dark
                      : theme.palette.secondary.light,
                },
              }}
            >
              <TableCell>
                {momentPhoenix(item.created_on).format("MM/DD/YY hh:mm A z")}
              </TableCell>
              <TableCell>{item.transactionid}</TableCell>
              <TableCell>{item.user_full_name}</TableCell>
              <TableCell>{item.transferred_by_full_name}</TableCell>
              <TableCell>
                {item.job_name
                  ? `${item.projectid} - ${item.job_name}`
                  : "[UNLISTED]"}
              </TableCell>
              <TableCell>{item.status_description}</TableCell>
              <TableCell>
                {item.approved_on
                  ? "Yes"
                  : item.rejected_on
                  ? "Rejected"
                  : "No"}
              </TableCell>
            </TableRow>
          );
        }}
        onRefresh={onRefresh}
        onEndReached={onLoadMore}
        loading={refreshing || loadingMore}
        ListFooterComponent={() => {
          return <ListFooter hasMore={hasMore} onClick={onLoadMore} />;
        }}
      />
    </>
  );
};

export default StockoutsAndPullsNeedToPost;
